
import { defineComponent } from "vue";

export default defineComponent({
  name: "FindComponent",
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    setURL(image: string): string {
      const urlcheck = /^(ftp|http|https):\/\/[^ "]+$/;
      return RegExp(urlcheck).exec(image)
        ? image
        : require("@/assets/images/Shared/" + image);
    },
  },
});
